import styled from 'styled-components'

export const MainText = styled.b`
  margin: 0 0 15px 0;
  display: block;
`

export const SecondText = styled.div`
  margin-bottom: 5px;
`
